import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PublicRoutes = ({ user }) => {
  if (!user.isAuthenticated) return <Outlet />;
  return <Navigate to={user.role === 'client' ? '/client/dashboard' : '/'} replace />;
};

export default PublicRoutes;
